import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { useAddEvidenceMutation, useUpdateEvidenceMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'EditEvidence',
  props: {
    value: Object
  },
  emits: ['done'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var form = ref(null);
    var submit = function submit(dialog) {
      var _form$value, _form$value$validate;
      if ((_form$value = form.value) !== null && _form$value !== void 0 && (_form$value$validate = _form$value.validate) !== null && _form$value$validate !== void 0 && _form$value$validate.call(_form$value)) {
        var _props$value;
        if (!((_props$value = props.value) !== null && _props$value !== void 0 && _props$value.id)) {
          add({
            input: _objectSpread({}, input.value)
          }, {
            context: {
              hasUpload: true
            }
          }).then(function (v) {
            var _v$data, _v$data$addEvidence;
            emit('done', v === null || v === void 0 ? void 0 : (_v$data = v.data) === null || _v$data === void 0 ? void 0 : (_v$data$addEvidence = _v$data.addEvidence) === null || _v$data$addEvidence === void 0 ? void 0 : _v$data$addEvidence.id);
            resetInput();
            dialog.value = false;
          });
        } else {
          update({
            input: _objectSpread(_objectSpread({}, input.value), {}, {
              id: props.value.id
            })
          }, {
            context: {
              hasUpload: true
            }
          }).then(function (v) {
            var _v$data2, _v$data2$updateEviden;
            emit('done', v === null || v === void 0 ? void 0 : (_v$data2 = v.data) === null || _v$data2 === void 0 ? void 0 : (_v$data2$updateEviden = _v$data2.updateEvidence) === null || _v$data2$updateEviden === void 0 ? void 0 : _v$data2$updateEviden.id);
            dialog.value = false;
          });
        }
      }
    };
    var _useAddEvidenceMutati = useAddEvidenceMutation(),
      add = _useAddEvidenceMutati.mutate,
      addLoading = _useAddEvidenceMutati.loading;
    var _useUpdateEvidenceMut = useUpdateEvidenceMutation(),
      update = _useUpdateEvidenceMut.mutate,
      updateLoading = _useUpdateEvidenceMut.loading;
    function emptyInput() {
      return {
        websiteUrl: '',
        comment: '',
        description: '',
        file: null
      };
    }
    function inputFromEvidence(evidence) {
      var _ref2, _ref3, _ref4;
      return {
        websiteUrl: (_ref2 = evidence === null || evidence === void 0 ? void 0 : evidence.websiteUrl) !== null && _ref2 !== void 0 ? _ref2 : '',
        comment: (_ref3 = evidence === null || evidence === void 0 ? void 0 : evidence.comment) !== null && _ref3 !== void 0 ? _ref3 : '',
        description: (_ref4 = evidence === null || evidence === void 0 ? void 0 : evidence.description) !== null && _ref4 !== void 0 ? _ref4 : '',
        file: null
      };
    }
    var input = ref(inputFromEvidence(props.value));
    var fileModel = computed({
      get: function get() {
        var file = input.value.file;
        if (file instanceof File) return file;
        if (Array.isArray(file) && file.every(function (entry) {
          return entry instanceof File;
        })) {
          return file;
        }
        return null;
      },
      set: function set(value) {
        input.value.file = value;
      }
    });
    function resetInput() {
      input.value = emptyInput();
    }
    var filename = computed(function () {
      var _props$value2;
      return (_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.filename;
    });
    watch(function () {
      return props.value;
    }, function (evidence) {
      if (!(evidence !== null && evidence !== void 0 && evidence.id)) return;
      input.value = inputFromEvidence(evidence);
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      form: form,
      submit: submit,
      add: add,
      addLoading: addLoading,
      update: update,
      updateLoading: updateLoading,
      emptyInput: emptyInput,
      inputFromEvidence: inputFromEvidence,
      input: input,
      fileModel: fileModel,
      resetInput: resetInput,
      filename: filename
    };
  }
});